const AlertDayOfWeek = Object.freeze({
  SUNDAY: 'Sunday',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday'
})
export default AlertDayOfWeek
// RESERVE BELOW
export type AlertDayOfWeekStrings = typeof AlertDayOfWeek[keyof typeof AlertDayOfWeek]
